module.exports = __webpack_public_path__ + "static/img/1.6a52d84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/1.jpg
// module id = t85V
// module chunks = 1